import { useMemo } from 'react';
import { useLocation } from 'react-router';

import { IdentificationQuery } from '../types';

const useGetIdentificationQuery = (): {
  queryParams: IdentificationQuery | null;
} => {
  const location = useLocation();

  const queryParams = useMemo<IdentificationQuery | null>(() => {
    const params = new URLSearchParams(location.search);
    const identificationTypeId = params.get('identificationTypeId');
    const identification = params.get('identification');
    if (!identificationTypeId || !identification) {
      return null;
    }
    const countryId = params.get('countryId') ?? undefined;
    return { identificationTypeId, identification, countryId };
  }, [location.search]);

  return { queryParams };
};

export default useGetIdentificationQuery;
